///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class GameOverScreen extends BaseScreen {

        fg:Phaser.GameObjects.Graphics;
        bg:Phaser.GameObjects.Graphics;
        txt:Phaser.GameObjects.Text;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'gameoverbg0000').setOrigin(0));
            

            this.txt = this.scene.add.text(game.scale.width/2-75, -100, "", {
                "fontFamily": "ArcadeClassic",
                "fontSize": 32,
                "color": "#FFFFFF",
                "align": 'center'
            });
            this.txt.setShadow(4, 4, '#000000', 4, true);
            this.txt.setOrigin(0.5, 0.5);
            this.add(this.txt);
            this.txt.setWordWrapWidth(300);
            nscs.gameplay.Gameplay.setText(this.txt, 'GameOver');

            this.fg = new Phaser.GameObjects.Graphics(this.scene);
            this.fg.setPosition(0, 0);
            this.fg.fillStyle(0x000000, 1);
            this.fg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.add(this.fg);
            this.scene.tweens.add({
                targets: this.fg,
                alpha: 0,
                duration: 500,
                onComplete: ()=>{
                    this.remove(this.fg);

                    this.scene.tweens.add({
                        targets: this.txt,
                        y: game.scale.height/2,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    
                    util.Functions.delayedCall(3000, ()=>{
                        nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene));
                    });
                }
            });
        }
    }
}